import { isProd as envIsProd } from "../configs/environment";

// Live query string. Must be read at call time — a module-load snapshot goes
// stale as soon as the app navigates (e.g. a WebView booted with ?hideNav=true
// would re-inject that param on every later navigation, hiding the bottom nav).
const getSearchParams = () => window.location.search;

const getParams = () => {
  const searchParams = window.location.search;
  const urlParams = new URLSearchParams(searchParams);
  const allParams = {};
  urlParams.forEach((value, key) => {
    allParams[key] = value;
  });
  return allParams;
};

const handleParams = (key, value) => {
  const searchParams = window.location.search;
  const urlParams = new URLSearchParams(searchParams);
  if (key) {
    urlParams.delete(key);
    urlParams.append(key, value);
  }
  return "?" + urlParams.toString();
};

// Safely read the cached measurement modules from sessionStorage.
// Returns [] when the key is missing (e.g. deep link, cleared session, or a
// sign-out flow that removed it) or when the stored value is malformed/not an
// array — avoids the "…find is not a function" crash on the TUG screens.
const getStoredTestModules = () => {
  try {
    const parsed = JSON.parse(sessionStorage.getItem("testMModule"));
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

// isProd is now determined by environment variable at build time
const isProd = envIsProd;

export {
  getParams,
  getSearchParams,
  handleParams,
  getStoredTestModules,
  isProd,
};
